var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 370,
    viewBox: "0 0 257 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00001C0 3.58173 3.58172 0 8 0H58.3782C60.6803 0 62.8708 0.991709 64.3897 2.72159L77.6103 17.7784C79.1292 19.5083 81.3197 20.5 83.6218 20.5H249C253.418 20.5 257 24.0817 257 28.5V362C257 366.418 253.418 370 249 370H8C3.58172 370 0 366.418 0 362V8.00001Z",
    fill: "#00130C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5H58.3779C60.4012 0.5 62.3324 1.31748 63.7393 2.75586L64.0137 3.05176L77.2344 18.1084C78.8482 19.9464 81.1761 21 83.6221 21H249C253.142 21 256.5 24.3579 256.5 28.5V362C256.5 366.142 253.142 369.5 249 369.5H8C3.85787 369.5 0.5 366.142 0.5 362V8C0.500005 3.85787 3.85787 0.5 8 0.5Z",
    stroke: "url(#paint0_linear_110_9275)",
    strokeOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_9275",
    x1: 0,
    y1: 0,
    x2: 326.081,
    y2: 76.8386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--app-accent-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "white",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--app-accent-secondary)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.3b71bffb3950a6069f2df95d0a5cdaa1.svg";
export { ForwardRef as ReactComponent };